import styled from 'styled-components';
import { Spin } from 'antd';

export const QuestionBlock = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const AnswerRow = styled.div`
  margin-top: ${({ theme }) => theme.spacing.space_2};
`;

export const LoadingSpinner = styled(Spin)`
  margin-top: ${({ theme }) => theme.spacing.space_3};
`;
